import { render, staticRenderFns } from "./SettingsAbsenceTypes.vue?vue&type=template&id=5874c550"
import script from "./SettingsAbsenceTypes.vue?vue&type=script&lang=js"
export * from "./SettingsAbsenceTypes.vue?vue&type=script&lang=js"
import style0 from "./SettingsAbsenceTypes.vue?vue&type=style&index=0&id=5874c550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports